module.exports = __webpack_public_path__ + "static/media/MT.d0825244.png";